export const SET_PLAYER_NAME = 'SET_PLAYER_NAME';
export const START_GAME = 'START_GAME';
export const END_GAME = 'END_GAME';
export const RESTART_GAME = 'RESTART_GAME';
export const UPDATE_SCORE = 'UPDATE_SCORE';
